// extracted by mini-css-extract-plugin
export default {"main":"DownloadButton_main__poq2n","icon":"DownloadButton_icon__kZ8tC"};